<template>
  <div class="plugin-wrapper">
    <div class="plugin-multi_line_text">
      <div class="layout">
        <div class="ms-row center-xs">
          <div class="col-xs-10 col-md-8 col-lg-6">
            <div :class="['plugin-main', collapsed ? '' : 'expanded']">
              <div class="heading-h2 title">{{config.title}}</div>
              <div class="content">
                <p v-for="(line, index) in config.lines" :key="index" v-html="htmlify(line.text)"></p>
              </div>
              <div class="actions">
                <a class="" @click="toggle">{{collapsed ? config.button : '收起'}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiLineText",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      collapsed: true
    }
  },
  created() {},
  methods: {
    toggle() {
      this.collapsed = !this.collapsed;
    },
    htmlify(str) {
      return str.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
    }
  }
}
</script>

<style lang="scss" scoped>
  .plugin-wrapper {
    .plugin-multi_line_text {
      text-align: center;
      padding: 2.1875rem 1.0625rem;
      .plugin-main {
        .title{
          font-size: 1.5625rem;
          margin-bottom: 1.125rem;
        }
        .content {
          height: 2.6rem;
          overflow: hidden;
          margin-bottom: .625rem;
          p { font-size: 13px; margin-bottom: 1rem; }
        }
        .actions {}
        &.expanded {
          .content {
            height: auto;
            overflow: visible;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  @media screen and (min-width: 48em) {
    .plugin-wrapper {
      .plugin-multi_line_text {
        padding: 2.1875rem 3.875rem;
      }
    }
  }
  @media screen and (min-width: 64em) {
    .plugin-wrapper {
      .plugin-multi_line_text {
        padding: 2.5rem 1.875rem;
        .plugin-main {
          .content {
            height: 2.6rem;
          }
        }
      }
    }
  }
  @media screen and (min-width: 75em) {
    .plugin-wrapper {
      .plugin-multi_line_text {
        padding: 3.125rem 0;
      }
    }
  }
  
  
</style>